import store from '../store/store'

// small cache for calculated ACLs and Permissions
let permissionsCache = []
let ACLCache = []

export const hasPermission = (...permissions) => {
  return (to, from, next) => {
    // if user didn't pass any permissions
    if (!permissions) {
      return next('/')
    }

    // reserved keyword to show section to anybody
    if (permissions[0] === 'all') {
      return next()
    }

    // if no cache
    if (!permissionsCache.length) {
      // get current account
      const activeAccount = store.getters['authentication/activeAccount']

      // cache permissions
      permissionsCache = activeAccount.permissions

      // check if there is any permissions at all
      // eslint-disable-next-line no-extra-boolean-cast
      if (!permissionsCache) {
        return next('/')
      }
    }

    // loop over permissions array and check them all
    for (const permission of permissions) {
      // check if permission in current.permissions array
      if (permissionsCache.indexOf(permission) === -1) {
        return next('/')
      }
    }

    return next()
  }
}

export const hasAnyPermission = (...permissions) => {
  return (to, from, next) => {
    // if user didn't pass any permissions
    if (!permissions) {
      return next('/')
    }

    // reserved keyword to show section to anybody
    if (permissions[0] === 'all') {
      return next()
    }

    // if no cache
    if (!permissionsCache.length) {
      // get current account
      const activeAccount = store.getters['authentication/activeAccount']

      // cache permissions
      permissionsCache = activeAccount.permissions

      // check if there is any permissions at all
      // eslint-disable-next-line no-extra-boolean-cast
      if (!permissionsCache) {
        return next('/')
      }
    }

    // loop over permissions array and check them all
    for (const permission of permissions) {
      // check if permission in current.permissions array
      if (permissionsCache.indexOf(permission) > -1) {
        return next()
      }
    }

    return next('/')
  }
}

export const canAccess = (...ACLs) => {
  return (to, from, next) => {
    // if user didn't pass any permissions
    if (!ACLs) {
      return next('/')
    }

    // if no cache
    if (!ACLCache.length) {
      // get current account
      const activeAccount = store.getters['authentication/activeAccount']

      // cache ACLs
      ACLCache = [...activeAccount.features, ...activeAccount.permissions]

      // merge permissions and features arrays
      // check if there is any ACLs at all
      // eslint-disable-next-line no-extra-boolean-cast
      if (!ACLCache) {
        return next('/')
      }
    }

    // loop over ACLs array and check them all
    for (const ACL of ACLs) {
      // check if ACL in ACLsArray array
      if (ACLCache.indexOf(ACL) === -1) {
        return next('/')
      }
    }

    return next()
  }
}
